import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import { Link as RouterLink } from 'react-router-dom';
import Searchbar from 'src/components/SearchBar';

export default function SubServices() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { id, service_name } = location.state || {};

  const [Addopenmodal, setAddOpenModal] = useState(false);
  const [deletemodal, setDeleteModal] = useState(false);
  const [subServiceId, setSubServiceId] = useState('');
  const [loading, setloading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [subServiceData, setSubServiceData] = useState([]);
  const [pagesCount, setPagesCount] = useState(1);
  const [page, setPage] = useState(1);
  const [subServiceName, setSubServiceName] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [search, setsearch] = useState('');
  const [searchloading, setsearchloading] = useState(false);
  const [error, setError] = useState(false);
  const [helperText, sethelperText] = useState('');
  const closeServiceModal = () => {
    setAddOpenModal(false);
    setSubServiceName('');
  };

  const handleDeleteModal = () => {
    setDeleteModal(false);
    setSubServiceId('');
  };

  useEffect(() => {
    HandleGetSubServices(1);
  }, []);

  const HandleGetSubServices = (pages) => {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('service_id', id);
    formData.append('page', pages);
    formData.append('search', search);

    fetch(api.get_sub_services, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSubServiceData(result.data);
          setPagesCount(Math.ceil(result.count / 10));
        } else {
          console.log('Error:', result.message);
        }
        setloading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setloading(false);
      });
  };

  const handleSaveSubService = () => {
    if (!subServiceName) {
      setError(true);
      sethelperText('Sub Service Name is required');
      return;
    }
    setSaveLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();

    subServiceId && formData.append('id', subServiceId);
    formData.append('service_id', id);
    formData.append('name', subServiceName);

    fetch(api.save_subservice, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setPage(1);
          // setPagesCount(1);
          HandleGetSubServices(1);
          closeServiceModal();
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        }
        setSaveLoading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setSaveLoading(false);
      });
  };

  const handleDeleteSubService = () => {
    setDeleteLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    subServiceId && formData.append('id', subServiceId);

    fetch(api.delete_sub_service, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          subServiceData.length = 0;
          setPage(1);
          HandleGetSubServices(1);
          handleDeleteModal();
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        }
        setDeleteLoading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setDeleteLoading(false);
      });
  };

  const handlesubservicemodal = (id, name) => {
    setSubServiceId(id);
    setSubServiceName(name);
    setAddOpenModal(true);
  };

  const handlesubservicemodalDelete = (id, name) => {
    setSubServiceId(id);
    setDeleteModal(true);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    HandleGetSubServices(value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubServiceChange = (e) => {
    const value = e.target.value;

    if (value.length <= 100) {
      if (value.toLowerCase() === service_name.toLowerCase()) {
        setError(true);
        sethelperText('Sub Service Name cannot be the same as Service Name.');
      } else {
        setError(false);
        setSubServiceName(value);
        sethelperText('');
      }
    }
  };

  return (
    <Page title={`Sub Services | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack alignItems={'center'}>
            <Stack direction="row">
              <IconButton
                style={{
                  marginRight: 12,
                  height: 40,
                  width: 70,
                  borderRadius: 5,
                  backgroundColor: 'rgba(249, 0, 1,0.1)'
                }}
                onClick={() => navigate(-1)}
              >
                <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
              </IconButton>

              <div style={{ width: '100%' }}>
                <Typography variant="h4" sx={{ color: '#f90001' }}>
                  Sub Services
                </Typography>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}
                >
                  <Typography sx={{ color: '#000000', fontSize: 11 }}>Service Name:</Typography>
                  <Typography
                    sx={{
                      color: '#f90001',
                      fontSize: 11,
                      // textDecoration: 'underline',
                      fontWeight: 'bold',
                      marginLeft: 0.5
                    }}
                  >
                    {service_name}
                  </Typography>
                </div>
              </div>
            </Stack>
          </Stack>

          <Stack>
            <Button
              variant="contained"
              sx={{ alignSelf: 'end', fontSize: 11 }}
              onClick={() => {
                handlesubservicemodal();
                setError(false);
                sethelperText('');
              }}
            >
              Add Sub Service
            </Button>
          </Stack>
        </Stack>

        <Modal
          open={Addopenmodal}
          onClose={closeServiceModal}
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              width: '45%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              padding: 2,
              border: '2px solid',
              borderColor: '#f00001',
              borderRadius: 0.5
            }}
          >
            <Box
              style={{
                flex: 1,
                display: 'flex', // Add this line
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 20
              }}
            >
              <Typography variant="h5" style={{ color: 'red', fontWeight: 'bold' }}>
                {subServiceId ? 'Edit Sub Service' : 'Add Sub Service'}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                gap: 2,
                flexDirection: 'column'
              }}
            >
              <TextField
                label="Service Name"
                variant="outlined"
                style={{ width: '100%' }}
                className="custom-textfield"
                disabled
                value={service_name}
              />
              <TextField
                label="Sub Service Name"
                variant="outlined"
                style={{ width: '100%' }}
                className="custom-textfield"
                onChange={handleSubServiceChange}
                error={error}
                // helperText={error ? 'Sub Service Name cannot be the same as Service Name.' : ''}
                helperText={helperText}
                // onChange={(e) => {
                //   if (e.target.value.length <= 100) {
                //     setSubServiceName(e.target.value);
                //   }
                // }}
                value={subServiceName}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={closeServiceModal}
                style={{ marginRight: 10 }}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={saveLoading}
                variant="contained"
                color="primary"
                onClick={() => {
                  handleSaveSubService();
                }}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Modal>

        <Dialog open={deletemodal} onClose={handleDeleteModal}>
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this Sub Service?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteModal} color="primary">
              No
            </Button>
            <LoadingButton
              loading={deleteLoading}
              variant="contained"
              onClick={handleDeleteSubService}
              color="primary"
              autoFocus
            >
              Yes
            </LoadingButton>
          </DialogActions>
        </Dialog>
        {/* <Box
          mt={2}
          // p={2}
          style={{
            flexDirection: 'row',
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between'
          }}
          className="top_options"
        >
          <Searchbar
            width={'90%'}
            value={search}
            setFunction={(val) => {
              setsearch(val);
            }}
            placeholder="Search"
            onEnter={() => {
              setsearchloading(true);
              setPage(1);
              HandleGetSubServices(1);
            }}
          />
          <LoadingButton
            style={{ width: '15%', marginLeft: '2.5%' }}
            loading={searchloading}
            variant="contained"
            onClick={() => {
              setPage(1);
              HandleGetSubServices(1);
            }}
            className="width_full"
          >
            <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
          </LoadingButton>
        </Box> */}
        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2, minWidth: 800 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#f00001', width: 300 }}>
                  Sub Service Name
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Created Date</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Steps</TableCell>

                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Action</TableCell>
              </TableRow>
            </TableHead>

            {!loading && subServiceData?.length !== 0 && (
              <TableBody>
                {subServiceData?.map((item, index) => (
                  <TableRow>
                    <TableCell scope="row" padding="normal" style={{ width: 150 }}>
                      <Stack direction="row" alignItems="center" spacing={1} style={{ width: 150 }}>
                        <Box
                          style={{
                            display: 'flex',
                            flexDirection: 'column'
                            // width: 120,
                          }}
                        >
                          <Typography variant="subtitle2" flexWrap={'wrap'}>
                            {item.name === 'undefined' ? 'N/A' : item.name}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>

                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>
                        {moment(item?.created_at).format('DD MMM YYYY') || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>{item?.step_count}</Typography>
                    </TableCell>
                    <TableCell align="center" style={{ width: 100 }}>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Edit">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            onClick={() => handlesubservicemodal(item?.id, item?.name)}
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            to="#"
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                              icon="icon-park-outline:edit"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Customers">
                          <Button
                            disabled={item?.step_count == 0 ? true : false}
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            component={RouterLink}
                            to="/dashboard/services/sub_services/customer_list"
                            state={{
                              service_id: id,
                              service_name: service_name,
                              sub_service_id: item?.id,
                              sub_service_name: item?.name,
                              is_pickup: item?.is_pickup
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                              icon="ic:twotone-person-add-alt"
                            />
                          </Button>
                        </Tooltip>

                        <Tooltip title="Add Steps">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            component={RouterLink}
                            to="/dashboard/services/sub_services/add_steps"
                            state={{
                              service_id: id,
                              service_name: service_name,
                              sub_service_id: item?.id,
                              sub_service_name: item?.name
                            }}
                            onClick={() => {
                              localStorage.setItem('stepsData', JSON.stringify(''));
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 19, color: '#ffffff' }}
                              icon="ic:twotone-post-add"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Delete">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            onClick={() => handlesubservicemodalDelete(item?.id, item?.name)}
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            to="#"
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                              icon="mingcute:delete-2-line"
                            />
                          </LoadingButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={5} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {subServiceData?.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={3} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      // height="55vh"
                      // backgroundColor="red"
                    >
                      <Typography variant="h6" gutterBottom color={'#f90001'}>
                        Sub service not found!
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && subServiceData?.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}
        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
